<template>
  <v-navigation-drawer v-model="drawer" color="" disable-resize-watcher>
    <v-list nav>
      <v-list-item ripple @click="onMainViewClick" title="Főoldal">
        <template v-slot:prepend>
          <v-icon icon="mdi-home"></v-icon>
        </template>
      </v-list-item>
      <v-list-item ripple @click="onAboutClick" title="Rólunk">
        <template v-slot:prepend>
          <v-icon icon="mdi-information"></v-icon>
        </template>
      </v-list-item>
      <v-list-item ripple @click="onGalleryClick" title="Galéria">
        <template v-slot:prepend>
          <v-icon icon="mdi-image"></v-icon>
        </template>
      </v-list-item>
      <v-list-item ripple @click="onConnectionClick" title="Kapcsolat">
        <template v-slot:prepend>
          <v-icon icon="mdi-phone"></v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
  <v-app-bar flat :elevation="elevation" :color="appBarColor">

    <v-app-bar-nav-icon
        v-if="$vuetify.display.smAndDown"
        @click="drawer = !drawer"
    />
    <div class="d-md-flex d-none ga-4 mx-auto">
      <v-btn v-bind:style="appBarTextColor" @click="onMainViewClick">Főoldal</v-btn>
      <v-btn v-bind:style="appBarTextColor" @click="onAboutClick">Rólunk</v-btn>
      <v-btn v-bind:style="appBarTextColor" @click="onGalleryClick">Galéria</v-btn>
      <v-btn v-bind:style="appBarTextColor" @click="onConnectionClick">Kapcsolat</v-btn>
    </div>
  </v-app-bar>
</template>
<script lang="ts">
import {Options, Vue} from "vue-class-component";

@Options({
  components: {},
  props: {
    appBarColor: String,
    appBarTextColor: String,
    elevation: String
  },
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    onAboutClick(): void {
      this.$router.push("company");
    },
    onConnectionClick(): void {
      this.$router.push("connection");
    },
    onGalleryClick(): void {
      this.$router.push("gallery");
    },
    onReferencesClick(): void {
      this.$router.push("references");
    },
    onMainViewClick(): void {
      this.$router.push("/");
    }
  }
})
export default class MainAppBar extends Vue {

}
</script>


<style scoped>

</style>